import { render, staticRenderFns } from "./closure-recommendations.vue?vue&type=template&id=6599f58c"
import script from "./closure-recommendations.vue?vue&type=script&lang=js"
export * from "./closure-recommendations.vue?vue&type=script&lang=js"
import style0 from "./closure-recommendations.vue?vue&type=style&index=0&id=6599f58c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports